import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eBienLaiViewTheoLopChiTietActionTypeIds,
  IBienLaiViewTheoLopChiTietActionTypes,
} from "../../action-types/bien-lai/IBienLaiViewTheoLopChiTietActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IBienLaiPrintRequest } from "../../action-types/bien-lai/IBienLaiViewChiTietActionTypes";
import { IBienLaiThuTheoLopRequest } from "../../../model/request/bien-lai/IBienLaiThuTheoLopRequest";

export function* bienLaiViewTheoLopChiTietSaga(): any {
  yield takeEvery(
    eBienLaiViewTheoLopChiTietActionTypeIds.LOAD_START,
    loadWorker,
  );
  yield takeLatest(
    eBienLaiViewTheoLopChiTietActionTypeIds.PRINT_START,
    printWorker,
  );
}

function* loadWorker(action: IBienLaiViewTheoLopChiTietActionTypes): any {
  const request = action.payload as IBienLaiThuTheoLopRequest;
  const res: IBaseRespone = yield call(
    bienLaiThuApi.SelectBySoPhieuGroup,
    request,
  );
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiViewTheoLopChiTiet.LOAD_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiViewTheoLopChiTiet.LOAD_ERRR({
        request,
        data: res.message ?? "Có lỗi",
      }),
    );
  }
}

function* printWorker(action: IBienLaiViewTheoLopChiTietActionTypes): any {
  const request = action.payload as IBienLaiPrintRequest;
  const payload = {
    hoc_ky: request.hoc_ky,
    nam_hoc: request.nam_hoc,
    so_phieu_group: request.id,
  } as IBienLaiThuTheoLopRequest;
  try {
    const res: IBaseRespone = yield call(bienLaiThuApi.PrintBienLai, request);
    if (res.is_success) {
      yield put(
        rootActions.bienLai.bienLaiViewTheoLopChiTiet.PRINT_SUCCESS({
          request: payload,
          data: res.data,
        }),
      );
    } else {
      yield put(
        rootActions.bienLai.bienLaiViewTheoLopChiTiet.PRINT_ERR({
          request: payload,
          data: res.message ?? "Có lỗi",
        }),
      );
    }
  } catch (error) {
    yield put(
      rootActions.bienLai.bienLaiViewTheoLopChiTiet.PRINT_ERR({
        request: payload,
        data: "Có lỗi",
      }),
    );
  }
}
